export const SCORE_MODAL_DATE_TIME_FORMAT = 'hh:mm A dddd MMM D, YYYY';
